import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faList, faTasks, faTh, faThLarge,
} from '@fortawesome/pro-light-svg-icons'
import type { IconDefinition } from '@fortawesome/pro-light-svg-icons'

import { Box, DashboardModule, Link } from '@domain-group/suit-theme'

import useFlipperKey from '@hooks/useFlipperKey'

import type { GalleryView, UseCampaignImagesPayload } from '../../hooks/useCampaignImages'

import GridView from './GridView'
import ListView from './ListView'

const VIEW_OPTIONS: { icon: IconDefinition, key: GalleryView }[] = [
  { icon: faThLarge, key: 'largeGrid' },
  { icon: faTh, key: 'grid' },
  { icon: faList, key: 'list' },
]

interface ViewToggleProps {
  callbacks: { setView: (view: GalleryView) => void },
  view: GalleryView,
}

const ViewToggle = (props: ViewToggleProps) => {
  const { callbacks: { setView }, view } = props

  return (
    <Box width="auto">
      {VIEW_OPTIONS.map(({ icon, key }) => {
        const active = view === key

        return (
          <Box
            as="a"
            alignItems="center"
            color={active ? 'bodyFontColor' : 'lightGrey'}
            justifyContent="center"
            key={key}
            marginLeft="medium"
            onClick={() => setView(key)}
            style={{ cursor: 'pointer' }}
          >
            <FontAwesomeIcon icon={icon} />
          </Box>
        )
      })}
    </Box>
  )
}

interface GalleryProps {
  campaignImagesPayload: UseCampaignImagesPayload,
}

const Gallery = (props: GalleryProps) => {
  const { campaignImagesPayload } = props

  const {
    callbacks: { setView, toggleView },
    isGridView,
    view,
  } = campaignImagesPayload

  const { isEnabled: photosPlansV2Enabled } = useFlipperKey('photos_plans_v2')

  const showListView = photosPlansV2Enabled ? view === 'list' : !isGridView

  const headerRight = photosPlansV2Enabled ? (
    <ViewToggle callbacks={{ setView }} view={view} />
  ) : (
    <Link onClick={() => toggleView()} textProps={{ fontSize: 'small' }}>
      <FontAwesomeIcon icon={isGridView ? faTasks : faTh} />{' '}
      {isGridView ? 'List View' : 'Grid View'}
    </Link>
  )

  return (
    <DashboardModule
      boxProps={{ marginBottom: 'large' }}
      headerRight={headerRight}
      title="Media"
    >
      {showListView ? (
        <ListView campaignImagesPayload={campaignImagesPayload} />
      ) : (
        <GridView
          campaignImagesPayload={campaignImagesPayload}
          largeGrid={photosPlansV2Enabled && view === 'largeGrid'}
        />
      )}
    </DashboardModule>
  )
}

export default Gallery
